import request from '@/utils/request'

export function findEsimSuppliers(params) {
  return request({
    url: `/esim_suppliers`,
    method: 'get',
    params
  })
}

export function findEsimSupplier(id) {
  return request({
    url: `/esim_suppliers/${id}`,
    method: 'get'
  })
}

export function findEsimSupplierName(id) {
  return request({
    url: `/esim_suppliers/${id}/name`,
    method: 'get'
  })
}

export function findEsimSupplierForm(id) {
  return request({
    url: `/esim_suppliers/${id}/form`,
    method: 'get'
  })
}

export function findEsimSupplierEsims(id, params) {
  return request({
    url: `/esim_suppliers/${id}/esims`,
    method: 'get',
    params
  })
}

export function createEsimSupplier(data) {
  return request({
    url: `/esim_suppliers`,
    method: 'post',
    data
  })
}

export function updateEsimSupplier(id, data) {
  return request({
    url: `/esim_suppliers/${id}`,
    method: 'put',
    data
  })
}
